// extracted by mini-css-extract-plugin
module.exports = {"customGalleryModal":"ModalScreen_customGalleryModal__y7gwt"};